export function formatExpiry(isoString: string): string {
    return new Date(isoString).toLocaleString('en-US', {
        weekday: 'long',
        month:   'long',
        day:     'numeric',
        hour:    'numeric',
        minute:  '2-digit',
        timeZone: 'America/Chicago',
    });
}